// src/pages/DashboardLayout.jsx
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../lib/AuthContext';
import logo from '../assets/logo.png';

const NAV = [
  { path: '/',             label: 'Overview',      exact: true },
  { path: '/portfolio',    label: 'Portfolio'                  },
  { path: '/risk',         label: 'Risk & Analytics'           },
  { path: '/history',      label: 'Trade History'              },
  { path: '/hypothetical', label: 'Hypothetical'               },
  { path: '/change-password', label: 'Change Password'         },
];

const ADMIN_NAV = [
  { path: '/admin', label: 'Admin' },
];

export default function DashboardLayout() {
  const { profile, isAdmin, signOut } = useAuth();
  const navigate = useNavigate();

  const initials = profile?.full_name
    ? profile.full_name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2)
    : profile?.email?.slice(0, 2).toUpperCase() || '??';

  return (
    <div className="app-layout">
      <aside className="sidebar">
        <div className="sidebar-header">
          <div className="sidebar-logo-wrap">
            <img src={logo} alt="Garnet Fund" className="sidebar-logo-icon" />
            <div>
              <div className="sidebar-logo"><span className="g-red">Garnet</span> Fund</div>
              <div className="sidebar-subtitle">Portfolio Management</div>
            </div>
          </div>
        </div>

        <nav className="sidebar-nav">
          <div className="nav-section-label">Navigation</div>
          {NAV.map(item => (
            <NavLink
              key={item.path}
              to={item.path}
              end={item.exact}
              className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
            >
              <span className="nav-diamond" />
              {item.label}
            </NavLink>
          ))}

          {isAdmin && (
            <>
              <div className="nav-section-label" style={{ marginTop: 8 }}>Management</div>
              {ADMIN_NAV.map(item => (
                <NavLink
                  key={item.path}
                  to={item.path}
                  className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
                >
                  <span className="nav-diamond" />
                  {item.label}
                </NavLink>
              ))}
            </>
          )}
        </nav>

        <div className="sidebar-footer">
          <div className="user-badge">
            <div className="user-avatar">{initials}</div>
            <div className="user-info">
              <div className="user-name">{profile?.full_name || profile?.email}</div>
              <div className="user-role">{profile?.role}</div>
            </div>
          </div>
          <button
            className="btn btn-secondary btn-sm"
            style={{ width: '100%', marginTop: 8, justifyContent: 'center' }}
            onClick={() => { signOut(); navigate('/login'); }}
          >
            Sign Out
          </button>
        </div>
      </aside>

      <main className="main-content">
        <Outlet />
      </main>
    </div>
  );
}
